import React, { useState } from "react";
import {
  Box,
  Button,
  Grid,
  InputLabel,
  TextField,
  Typography,
  MenuItem,
  TextareaAutosize,
} from "@mui/material";
import { useDispatch } from "react-redux";
import {
  TransparentDialog,
  IgniteDialogTitle,
  IgniteDialogContent,
  DialogCloseBtn,
} from "styles/igniteTalks.styles";
import {
  mostPopularTalks,
  editMostPopularTalks,
} from "../../Redux/IgniteTalks";

const AddCardContent = ({
  editCardContent,
  setEditCardContent,
  openAddContentDialog,
  setOpenAddContentDialog,
}) => {
  const formatToInputDate = (strDate) => {
    const d = new Date(strDate);
    const year = d?.getFullYear();
    const month = String(d?.getMonth() + 1).padStart(2, "0");
    const day = String(d?.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };
  const [title, setTitle] = useState(editCardContent?.title || "");
  const [description, setDescription] = useState(
    editCardContent?.description || ""
  );
  const [date, setDate] = useState(
    formatToInputDate(editCardContent?.talks_date) || null
  );
  const [hours, setHours] = useState(editCardContent?.hours || "");
  const [minutes, setMinutes] = useState(editCardContent?.minutes || "");
  const [talksLink, setTalksLink] = useState(editCardContent?.talks_link || "");
  const selectedTalksId = editCardContent?.id;
  const isEditMode = Object.keys(editCardContent).length > 0 ? true : false;


  let maxTitleLength = 50;
  let maxDescriptionLength = 209;
  const dispatch = useDispatch();

  const dialogCloseBtn = () => {
    setOpenAddContentDialog(null);
    setTitle("");
    setDescription("");
    setHours("");
    setMinutes("");
    setTalksLink("");
    setDate(null);
    setEditCardContent([])
  };
  const AddSessionsHandler = () => {
    const talksDetails = {
      title,
      description,
      minutes,
      hours,
      talksLink,
      date,
    };
    if (isEditMode) {
      dispatch(editMostPopularTalks(talksDetails, selectedTalksId));
    } else {
      dispatch(mostPopularTalks(talksDetails));
    }
    setTitle("");
    setDescription("");
    setHours("");
    setMinutes("");
    setTalksLink("");
    setDate(null);
    setOpenAddContentDialog(null);
    setEditCardContent([])
  };
  return (
    <>
      {openAddContentDialog && (
        <TransparentDialog
          open={Boolean(openAddContentDialog)}
          onClose={() => setOpenAddContentDialog(null)}
          fullWidth
        >
          <IgniteDialogTitle>
            Add Talks
            <DialogCloseBtn
              title="Close"
              variant="contained"
              onClick={dialogCloseBtn}
            >
              X
            </DialogCloseBtn>
          </IgniteDialogTitle>
          <IgniteDialogContent>
            <Box component="form" onSubmit={(e) => e.preventDefault()}>
              <Grid container spacing={2} size={12}>
                {/* Title */}
                <Grid size={12}>
                  <Typography mb={0.5}>Title :</Typography>

                  <Grid container spacing={1}>
                    <Grid size={10}>
                      <TextField
                        fullWidth
                        size="small"
                        required
                        placeholder="Enter title"
                        value={title}
                        slotProps={{
                          input: {
                            maxLength: maxTitleLength,
                          },
                        }}
                        onChange={(e) => {
                          const value = e.target.value;
                          if (value.length <= maxTitleLength) {
                            setTitle(value);
                          }
                        }}
                      />
                    </Grid>
                    <Grid size={2} alignSelf={"self-end"}>
                      <Typography variant="caption">
                        {title.length}/{maxTitleLength}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>

                {/* Description */}
                <Grid item spacing={2} size={12}>
                  <Typography>Description :</Typography>
                  <Grid container spacing={1}>
                    <Grid size={10}>
                      <TextField
                        fullWidth
                        multiline
                        required
                        rows={3}
                        size="small"
                        value={description}
                        slotProps={{
                          input: {
                            maxLength: maxDescriptionLength,
                          },
                        }}
                        onChange={(e) => {
                          setDescription(
                            e.target.value.slice(0, maxDescriptionLength)
                          );
                        }}
                        placeholder="Enter description"
                      />
                    </Grid>
                    <Grid size={2} alignSelf={"self-end"}>
                      <Typography variant="caption">
                        {description.length}/{maxDescriptionLength}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>

                {/* Video Link */}
                <Grid size={12}>
                  <Typography mb={0.5}>Link :</Typography>

                  <Grid container spacing={1}>
                    <Grid size={10}>
                      <TextField
                        fullWidth
                        size="small"
                        placeholder="Enter Link"
                        value={talksLink}
                        onChange={(e) => {
                          setTalksLink(e.target.value);
                        }}
                      />
                    </Grid>
                  </Grid>
                </Grid>
                {/* Duration */}
                <Grid >
                  <Typography mb={1}>Duration :</Typography>
                <Grid container item size={8} spacing={2} alignItems="center">
                  <Grid container item size={9} spacing={2}>
                    <Grid item size={6}>
                      <TextField
                        value={hours}
                        type="number"
                        size="small"
                        fullWidth
                        onChange={(e) => setHours(e.target.value)}
                        label="Hours"
                      />
                    </Grid>

                    <Grid item size={6}>
                      <TextField
                        value={minutes}
                        type="number"
                        size="small"
                        fullWidth
                        required
                        onChange={(e) => setMinutes(e.target.value)}
                        label="Minutes"
                      />
                    </Grid>
                  </Grid>
                </Grid>
                </Grid>
                {/* Date */}
                <Grid item size={3}>
                  <Typography>Date :</Typography>
                  <TextField
                    value={date}
                    type="date"
                    size="small"
                    fullWidth
                    required
                    onChange={(e) => setDate(e.target.value)}
                  />
                </Grid>
                <Grid container spacing={2}>
                  <Typography></Typography>
                  <Grid size={12}>
                    <Button
                      type="submit"
                      variant="contained"
                      fullWidth
                      onClick={AddSessionsHandler}
                    >
                      Submit
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
            </Box>
          </IgniteDialogContent>
        </TransparentDialog>
      )}
    </>
  );
};

export default AddCardContent;
